<template>
<v-card flat v-if="room_standards">
    <v-card-text class="pb-5">
        <!-- {{room_standards}} -->
        <div class="pa-1">
            <v-select v-model="item.standard" :label="$t('room_type.detail.standard_room_type')" :items="room_standards" item-value="slug" required :hint="$t('room_type.description.info_text.standard')" persistent-hint :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                :rules="rules.standard" @input="handleEmptyData()">
                <template v-slot:selection="data">{{ $t('room-type-standards.' + data.item.slug + '.name') }}</template>
                <template v-slot:item="data">
                    <div>
                        <div class="regular">{{ $t('room-type-standards.' + data.item.slug + '.name') }}</div>
                        <div class="faded">{{ $t('room-type-standards.' + data.item.slug + '.description') }}</div>
                    </div>
                </template>
            </v-select>
        </div>
        <div class="pa-1" v-if="item.standard">
            <v-autocomplete v-model="item.slug" :label="$t('room_type.detail.slug')" :items="filtered_items" :search-input="search" item-value="slug" item-text="text" :hint="$t('room_type.description.info_text.slug')" persistent-hint :rules="rules.slug">
                <template slot="append">
                    <v-icon>search</v-icon>
                    <div class="v-input__icon v-input__icon--append">
                        <v-icon>arrow_drop_down</v-icon>
                    </div>
                </template>
            </v-autocomplete>
        </div>
        <div class="pa-1">
            <v-text-field :label="$t('room_type.detail.name')" v-model="item.name" required />
        </div>
        <div class="">{{ $t('room_type.detail.title.extra_beds_and_occupancy') }}</div>
        <v-row no-gutters>
            <v-col md="6" cols="12" class="pa-2">
                <v-text-field v-model="item.config.occupancy" :label="$t('room_type.detail.occupancy')" required :hint="$t('room_type.description.info_text.occupancy')" persistent-hint :rules="rules.value" />
            </v-col>
            <v-col md="6" cols="12" class="pa-2" v-if="extra_beds">
                <v-select v-model="item.config.extra_beds" :label="$t('room_type.detail.extra_beds')" :items="extra_beds_values" :menu-props="{transition:'scale-transition', 'offset-y': ''}" :hint="$t('room_type.description.info_text.extra_beds')"
                    persistent-hint />
            </v-col>
            <v-col md="6" cols="12" class="pa-2" v-if="children">
                <v-select v-model="item.config.small_child_in_bed" :label="$t('room_type.detail.small_child')" :items="boolean_values" item-text="text" item-value="value" :menu-props="{transition:'scale-transition', 'offset-y': ''}" required :hint="$t('room_type.description.info_text.small_child')"
                    persistent-hint />
            </v-col>
            <v-col md="6" cols="12" class="pa-2" v-if="single_stay">
                <v-select v-model="item.config.single_stay" :label="$t('room_type.detail.single_stay')" :items="boolean_values" item-text="text" item-value="value" :menu-props="{transition:'scale-transition', 'offset-y': ''}" required :hint="$t('room_type.description.info_text.single_stay')"
                    persistent-hint />
            </v-col>
        </v-row>

    </v-card-text>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import IMInfo from '../../../small-components/IMInfo.vue';

export default {

    props: {
        item: Object,
        hotel_id: [String, Number],
        active: Object,
        room_standards: Array,
        single_stay: {
            type: Boolean,
            default: false
        },
        extra_beds: {
            type: Boolean,
            default: false
        },
        children: {
            type: Boolean,
            default: false
        },
    },
    name: `hotel-details`,
    components: {
        "im-info": IMInfo,
    },
    data() {
        return {
            search: null,
            items: [],
            // room_standards: [],

            rooms_types_standards: [],
            extra_beds_values: [0, 1, 2, 3],
            boolean_values: [
                {
                    text: 'Da',
                    value: 1
                }, {
                    text: 'Nu',
                    value: 0
                }
            ],
        };
    },

    created() {},

    watch: {},

    computed: {

        slugs() {
            if(!!this.item.standard && (this.room_standards.length > 0)) {
                let array = this.room_standards.find(function (standard) {
                    if(standard.slug == this.item.standard) {
                        return standard.types
                    }
                }.bind(this))

                return array.types
            } else {
                return []
            }
        },

        lang_slugs() {
            if(!!this.item.standard && (this.room_standards.length > 0)) {
                let array = [];
                array = this.room_standards.find(function (standard) {
                    if(standard.slug == this.item.standard) {
                        return standard.types
                    }
                }.bind(this))
                let room_slugs = [];
                if(!!array) {
                    room_slugs = array.types.map(function (item) {
                        return {
                            slug: item.slug,
                            text: this.$i18n.messages[this.$i18n.locale]['room_type_slug'][item.slug]
                        }
                    }.bind(this))
                }
                return room_slugs;
            } else {
                return []
            }
        },

        filtered_items() {
            if(!this.search) {
                return this.lang_slugs;
            }
            let search = this.latinize(this.search.toLowerCase());
            let that = this;
            return this.lang_slugs.filter(function (item) {
                return that.latinize(item.text.toLowerCase())
                    .search(search) > -1;
            });
        },

        rules() {
            return {
                name: [v => !!v || this.$t('room_type.detail.form_rules.name')],
                description: [v => !!v || this.$t('room_type.detail.form_rules.description')],
                value: [v => !!v || this.$t('room_type.detail.form_rules.value')],
                standard: [v => !!v || this.$t('room_type.detail.form_rules.value')],
                slug: [v => !!v || this.$t('room_type.detail.form_rules.value')],
            }
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        latinize(str) {
            return str.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
        },

        handleEmptyData() {
            this.item.slug = this.item.standard;
            switch (this.item.standard) {
            case 'apartment':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 3;
                break;
            case 'bed':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'double':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'double-twin':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'family':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'king':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'queen':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'triple':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 3;
                break;
            case 'quad':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 4;
                break;
            case 'single':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 1;
                break;
            case 'twin':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'studio':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 2;
                break;
            case 'villa':
                this.item.description = this.$i18n.messages.ro['room-type-standards'][this.item.standard].description;
                this.item.config.occupancy = 4;
                break;

            }
        },

    },
};
</script>
